import { render, staticRenderFns } from "./_accordion.vue?vue&type=template&id=2dd9ccfd&"
import script from "./_accordion.vue?vue&type=script&lang=js&"
export * from "./_accordion.vue?vue&type=script&lang=js&"
import style0 from "./_accordion.vue?vue&type=style&index=0&id=2dd9ccfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports